import { Stack, Container, Typography } from '@mui/material';
import PositionTableView from 'src/sections/management/user/tabs/position/position-table';

export default function PositionView() {
  return (
    <Container>
      <Stack spacing={3}>
        <Typography variant="h4" gutterBottom>
          การตัดซื้อ/ขาย
        </Typography>
        <PositionTableView />
      </Stack>
    </Container>
  );
}
